/**
 * Recursively strips Apollo's __typename metadata from any object or array.
 * Call this before sending cached query data back as a GraphQL mutation input —
 * GraphQLInputObjectType fields reject __typename and will cause validation errors.
 */
export const removeTypename = (value) => {
  if (Array.isArray(value)) {
    return value.map(removeTypename);
  }
  if (value !== null && typeof value === "object") {
    const cleaned = {};
    for (const key of Object.keys(value)) {
      if (key !== "__typename") {
        cleaned[key] = removeTypename(value[key]);
      }
    }
    return cleaned;
  }
  return value;
};
